<!-- 学习班 修改 -->
<template>
  <div class="form_box">
    <div class="form_box__header">
      <AppPageHeader></AppPageHeader>
    </div>
    <el-card class="box-card">
      <div class="form_box__group__item">
        <div class="form_box__group__item__title">
          名称:
        </div>
        <div class="form_box__group__item__content">
          <el-input v-model="title" placeholder="请输入学习班名称" ref="input_title"  style="width: 400px;"></el-input>
        </div>
      </div>
      <div class="form_box__group__item"  v-if="showClassType">
        <div class="form_box__group__item__title">
          所属学习班分类:
        </div>
        <div class="form_box__group__item__content">
            <studyclassTidSelect @getsctId="getStudyClassTypeId" :showTitle="false" ref="StudyClassTypeId"></studyclassTidSelect>
        </div>
      </div>
      <div class="form_box__group__item" v-if="showTypeSelect">
        <div class="form_box__group__item__title">
          类型:
        </div>
        <div class="form_box__group__item__content">
              <el-radio-group v-model="type">
                <el-radio :label="0">党组织生活</el-radio>
                <el-radio :label="1">单位课程</el-radio>
              </el-radio-group>
        </div>
      </div>
      <div class="form_box__group__item" v-if="type == 1">
        <div class="form_box__group__item__title">
          开 班 单 位:
        </div>
        <div class="form_box__group__item__content">
          <ClassUnitCascader @onValueChanged="onUnitValueChanged" ref="classUnitCascader"></ClassUnitCascader>           
        </div>
      </div>
      <div class="form_box__group__item" v-if="type == 0">
        <div class="form_box__group__item__title">
          开班党组织:
        </div>
        <div class="form_box__group__item__content">
          <partyorgCascader @onValueChanged="onPartyOrgValueChanged" ref="partyorgCascader"></partyorgCascader>           
        </div>
      </div>
    </el-card>
    <el-card class="box-card" style="margin-top: 20px;" v-loading="loading">
      <el-button style="margin-top: 12px;" type="primary" @click="publish">更新</el-button>
    </el-card>
  </div>
</template>


<script>
import { BaseVue } from "@/mixin/index";
import { studyclassTidSelect } from "@/views/module/studyclass/components/";
import { studyclassEditInitApi, studyclassEditSaveApi } from "@/api/module/studyclass/studyclass";
import { partyorgCascader } from "@/views/module/partyOrganization/components/";
import { ClassUnitCascader } from "@/views/module/classunit/components/";

export default {
  name: "StudyClassEdit",
  
  mixins: [BaseVue],
  
  components: {
    studyclassTidSelect,
    partyorgCascader,
    ClassUnitCascader
  },
  
  data() {
    return {
      loading: false,
      id: "",
      title: "",
      tid: "",
      type: "",
      unitid: "",
      partyorgid: ""  // 开班支部 id
    };
  },
  
  computed: {
    showClassType() {
      var show = false;

      if (this.roleid == "00003") {
        return true;
      }

      if (this.roleid == "00001" && this.type == 1) {
        return true;
      }

      if (this.isadmin && this.type == 1) {
        return true;
      }
      
      return show;
    },
    
    showTypeSelect() {
      if (this.isAdmin) {
        return true;
      }
      if (this.isRoleinfo.hasPer50001 && this.isRoleinfo.hasPer50002) {
        return true;
      }
      return false;
    },
    
    typeIsPartyOrg() {
      return this.type == 0;
    },
    
    typeIsUnit() {
      return this.type == 1;
    }
  },
  
  methods: {
    init() {
      studyclassEditInitApi(this.id)
        .then(response => {
          this.title = response.title;
          this.id = response.id;
          this.tid = response.tid;
          this.type = response.type;
          
          if (this.typeIsPartyOrg) {
            console.log("this.typeIsPartyOrg", this.typeIsPartyOrg);
            this.partyorgid = response.partyid;
            this.$nextTick(() => {
              this.$refs.partyorgCascader.initData(this.partyorgid);
            });
          }
          
          if (this.typeIsUnit) {
            this.unitid = response.unitid;
            this.$nextTick(() => {
              this.$refs.StudyClassTypeId.initDate(this.tid);
              this.$refs.classUnitCascader.initData(this.unitid);
            });
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    publish() {
      if (!this.title) {
        this.$message.error("学习班名称不能为空！");
        this.loading = false;
        return false;
      }
      if (!this.tid) {
        this.$message.error("学习班类型不能为空！");
        this.loading = false;
        return false;
      }
      if (this.typeIsPartyOrg) {
        if (!this.partyorgid) {
          this.$message.error("开班支部不能为空！");
          this.loading = false;
          return false;
        }  
      }
      if (this.typeIsUnit) {
        if (!this.unitid) {
          this.$message.error("开班单位不能为空！");
          this.loading = false;
          return false;
        }      
      }
      
      this.loading = true;
      const data = {
        id: this.id,
        tid: this.tid,
        title: this.title,
        type: this.type,
        unitid: this.unitid,
        partyorgid: this.partyorgid
      };
      
      studyclassEditSaveApi(data)
        .then(response => {
          this.$message({
            message: "操作成功,稍后该标签页会关闭！",
            type: "success"
          });
          setTimeout(() => {
            window.close();
          }, 2000);
        }).finally(() => {
          this.loading = false;
        });
    },
    
    getStudyClassTypeId(e) {
      this.tid = e.studyClassId;
    },
    
    getStudyClassTypeType(e) {
      this.type = e;
    },
    
    onUnitValueChanged(data) {
      if (typeof data == 'string') {
        this.unitid = data;
      } else {
        this.unitid = data[data.length - 1];
      }
    },
    
    onPartyOrgValueChanged(data) {
      if (typeof data == 'string') {
        this.partyorgid = data;
      } else {
        this.partyorgid = data[data.length - 1];
      }
    }
  },
  
  mounted() {
    this.id = this.$route.query.id;
    this.init();
    
    if (!this.showTypeSelect) {
      if (this.isRoleinfo.hasPer50001) {
        this.type = 1;
      }
      if (this.isRoleinfo.hasPer50002) {
        this.type = 0;
      }
    }
  }
};
</script>
<style scoped lang="scss">
.form_box {
  .form_box__item {
    margin-bottom: 15px;
    font-size: 14px;
    color: #303133;
    span {
      margin-right: 50px;
      white-space: nowrap;
    }
    .form_box__item__input {
      margin-left: 0;
    }
  }
}
::v-deep .el-input--suffix .el-input__inner{
  width: 260px;
}
</style>

